import { FC, Ref } from 'react';

import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import { ContractType } from '@telialt/models/src/EshopModel';
import { selectIsFullPricePayment, selectRentPlan } from '@telialt/utils/src/eshopSelectors';
import { TeliaSegment, useSegment } from '@telialt/utils/src/segment';

import { PriceWithMonthlyPayment } from './PriceWithMonthlyPayment';
import { PriceWithoutMonthlyPayment } from './PriceWithoutMonthlyPayment';
import { PriceWithResidualAmount } from './PriceWithResidualAmount';
import { ProductOfferPrices } from './ProductOfferPrices/ProductOfferPrices';

type Props = {
    ref: Ref<HTMLElement>;
};

export const TopPrice: FC<Props> = ({ ref }) => {
    const segment = useSegment();
    const { cart } = useCartQuery();

    const isFullPricePayment = selectIsFullPricePayment(cart);
    const rentingPlanEntry = selectRentPlan(cart);

    if (cart.contractType === ContractType.Renting) {
        return <PriceWithResidualAmount rentingPlan={rentingPlanEntry} ref={ref} />;
    }
    if (segment === TeliaSegment.B2c) {
        return <ProductOfferPrices ref={ref} />;
    }
    if (isFullPricePayment) {
        return <PriceWithoutMonthlyPayment ref={ref} />;
    }

    return <PriceWithMonthlyPayment ref={ref} />;
};
